import { render } from "./YourPerformance.vue?vue&type=template&id=188bc453&scoped=true"
import script from "./YourPerformance.vue?vue&type=script&lang=js"
export * from "./YourPerformance.vue?vue&type=script&lang=js"

import "./YourPerformance.vue?vue&type=style&index=0&id=188bc453&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188bc453"]])

export default __exports__